import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isMobileDevice, getValueOrnull } from '../../../common/utilities/utils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import Modal from '../../../molecules/Modal';
import { ButtonComp } from '../../../atoms/Buttons';
import ErrorAlertFormInsideModel from 'molecules/Alert/Container/AlertFormInsideModel';
import CartAlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import { MaterialTextInput as TextInput } from 'atoms/MaterialInput';
import { checkGiftCardBalance } from '@kfc-global/react-shared/redux/Actions/GiftCheckBalanceAction';
import { GIFTCARD_CONSTANTS } from '../Constants/giftcardConstants';
import HOME_PAGE_CONTAINER_CONSTANTS from 'components/homePageContainer/Constants/homePageContainerConstants';
import { embeddedErrorMessageAnalyticFn } from 'components/checkout/CheckoutFn';

const { KFC_Gift_Card } = HOME_PAGE_CONTAINER_CONSTANTS;

export const CheckbalancdeModal = props => {
  const { CHECKBALANCE_MODAL, EMAIL_REGEX, SHOWBALANCE_MODAL, ACTIVE, INACTIVE, MANDATORY_NOTE } = GIFTCARD_CONSTANTS;

  const { isOpen, handleClose, tenantId } = props;
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const [mailid, setMailid] = useState('');
  const [balance, setBalance] = useState('');
  const [buttonDisable, setButtonDisable] = useState(true);
  const [checkBalanceRes, setCheckBalanceRes] = useState(false);
  const [showError, setShowError] = useState(false);
  const dispatch = useDispatch();

  const { tenantReducer, profileReducer, createBalanceReducer } = useSelector(data => {
    return data;
  });
  const { currencySymbol } = tenantReducer;
  const { response } = createBalanceReducer;

  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setIsMobile(isMobileView);
  };
  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  useEffect(() => {
    const status = response.cardStatus;
    switch (status) {
      case ACTIVE:
        setBalance(response.cardBalance);
        setCheckBalanceRes(true);
        setShowError(false);
        break;
      case INACTIVE:
        setCheckBalanceRes(false);
        setShowError(true);
        break;
      default:
        break;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  const [yourEmail, setYourEmail] = useState({
    value: '',
    errorMessage: '',
    error: false,
  });

  const [cardNumberState, setCardNumberState] = useState({
    value: '',
    errorMessage: '',
    error: false,
  });
  const [pinNumberState, setPinNumberState] = useState({
    value: '',
    errorMessage: '',
    error: false,
  });

  useEffect(() => {
    const cardPinAndMailPresent = (cardNumberState.value && pinNumberState.value) !== '';
    const cardPinLength = (cardNumberState.error || pinNumberState.error) === false;
    if (cardPinAndMailPresent && cardPinLength) {
      setButtonDisable(false);
    } else {
      setButtonDisable(true);
    }
  }, [cardNumberState, pinNumberState]);

  useEffect(() => {
    embeddedErrorMessageAnalyticFn(KFC_Gift_Card, cardNumberState.error, cardNumberState.errorMessage);
  }, [cardNumberState.errorMessage, cardNumberState.error]);

  useEffect(() => {
    embeddedErrorMessageAnalyticFn(KFC_Gift_Card, pinNumberState.error, pinNumberState.errorMessage);
  }, [pinNumberState.errorMessage, pinNumberState.error]);

  useEffect(() => {
    embeddedErrorMessageAnalyticFn(KFC_Gift_Card, yourEmail.error, yourEmail.errorMessage);
  }, [yourEmail.errorMessage, yourEmail.error]);

  const validEmail = email => {
    let pattern = EMAIL_REGEX;
    return(
      pattern.test(email)
    )
  };
  const mailChangeHandler = e => {
    setMailid(e.target.value);
    let emailObj = { ...yourEmail };
    emailObj.value = mailid;
    if (mailid && !validEmail(mailid)) {
      emailObj.error = true;
      emailObj.errorMessage = translateWithI18Next('invalidEmailErrMsg');
    } else {
      emailObj.error = false;
      emailObj.errorMessage = '';
    }
    setYourEmail({
      ...emailObj,
    });
  };

  const cardKeypressHandler = e => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const getCardNumberData = (cardNumberObject, inputCardNumber) => {
    let cardObj = { ...cardNumberObject };
    cardObj.value = inputCardNumber;
    if (!inputCardNumber) {
      cardObj.error = true;
      cardObj.errorMessage = translateWithI18Next(GIFTCARD_CONSTANTS.GIFTCARD_ERROR);
    } else if (inputCardNumber.length < 16 || isNaN(inputCardNumber)) {
      cardObj.error = true;
      cardObj.errorMessage = translateWithI18Next('invalidcardNumber');
    } else {
      cardObj.error = false;
      cardObj.errorMessage = '';
    }
    return cardObj;
  };

  const getPinNumberData = (pinNumberObject, inputPinNumber) => {
    let pinObj = { ...pinNumberObject };
    pinObj.value = inputPinNumber;
    if (!inputPinNumber) {
      pinObj.error = true;
      pinObj.errorMessage = translateWithI18Next(GIFTCARD_CONSTANTS.PINNUMBER_ERROR);
    } else if (inputPinNumber.length !== 6 || isNaN(inputPinNumber)) {
      pinObj.error = true;
      pinObj.errorMessage = translateWithI18Next('invalidPin');
    } else {
      pinObj.error = false;
      pinObj.errorMessage = '';
    }
    return pinObj;
  };

  const oncancelBtn = () => {
    setCardNumberState({ value: '' });
    setPinNumberState({ value: '' });
    setMailid('');
    setYourEmail({ value: '' });
  };

  const submitHandler = e => {
    if ((cardNumberState.value && pinNumberState.value) !== '') {
      let customerId = profileReducer.customerId;
      const reqPayload = {
        customerId,
        tenantId: tenantId,
        body: {
          cardNumber: cardNumberState.value,
          cardPin: pinNumberState.value,
        },
      };
      console.log('cardNumber', cardNumberState.value);
      if (getValueOrnull(tenantId)) {
        dispatch(checkGiftCardBalance(reqPayload));
      }
    }
  };

  const getUserData = (name, callBack) => {
    name && callBack();
  };
  const updateUserDetails = event => {
    const inputValue = event.target.value;
    const inputName = event.target.name;
    getUserData(inputName === 'cardNumber', () =>
      setCardNumberState({
        ...getCardNumberData(cardNumberState, inputValue),
      }),
    );

    getUserData(inputName === 'pinNumber', () =>
      setPinNumberState({
        ...getPinNumberData(pinNumberState, inputValue),
      }),
    );
  };

  const resetHandler = () => {
    setCardNumberState({ value: '' });
    setPinNumberState({ value: '' });
    setBalance('');
    setCheckBalanceRes(false);
    setYourEmail({ value: '' });
    setMailid('');
    setCheckBalanceRes(false);
  };

  const InformationArea = (
    <div>
      <div className='GiftbalanceInputArea'>
        <div className='balanceHeader'>
          <h3 className='InputboxHeading'>{translateWithI18Next(CHECKBALANCE_MODAL.GIFTCARD_HEADER)}</h3>
          {!isMobile && <p className='mandatory-note'>{translateWithI18Next(MANDATORY_NOTE)}</p>}
        </div>
        <div className='inputcardNumbox'>
          <TextInput
            data-testid='card-no'
            className={cardNumberState.error ? 'error-text' : 'details'}
            name='cardNumber'
            placeholder={translateWithI18Next(CHECKBALANCE_MODAL.GIFTCARDNUM_INPUT)}
            value={cardNumberState.value}
            onChange={updateUserDetails}
            onKeyPress={e => cardKeypressHandler(e)}
            maxLength={16}
            helperTextClassName='error-text'
            helperText={cardNumberState.errorMessage}
            error={cardNumberState.error}
            required
          />
        </div>
        <div className='inputpinNumbox'>
          <TextInput
            data-testid='pin-no'
            className={pinNumberState.error ? 'error-text' : 'details'}
            name='pinNumber'
            placeholder={translateWithI18Next(CHECKBALANCE_MODAL.GIFTCARDPN_INPUT)}
            value={pinNumberState.value}
            onChange={updateUserDetails}
            maxLength={6}
            helperTextClassName='error-text'
            helperText={pinNumberState.errorMessage}
            error={pinNumberState.error}
            required
          />
        </div>
        <div className='inputmailbox'>
          <TextInput
            data-testid='email-id'
            className={yourEmail.error ? 'error-text' : 'details'}
            type='email'
            name='mailId'
            placeholder={translateWithI18Next(CHECKBALANCE_MODAL.EMAIL_ADDR)}
            value={mailid}
            onChange={e => mailChangeHandler(e)}
            helperTextClassName='error-text'
            helperText={yourEmail.errorMessage}
            error={yourEmail.error}
            required
          />
        </div>
      </div>
    </div>
  );

  const errormodalCancel = () => {
    resetHandler();
    setShowError(false);
  };

  const modalProps = isMobile
    ? {
        role: 'dialog',
        modalTitleId: 'CheckBalancepopup',
        show: isOpen,
        classNames: 'giftcard-checkbalance-modal',
        showCloseBtn: true,
        closeButtonHandler: handleClose,
        autoFocus: true,
        modalTitle: translateWithI18Next('giftcardCheckbalnaceTitle'),
        closeDataTestId: 'giftcheck-balance',
      }
    : {
        role: 'dialog',
        modalTitleId: 'CheckBalancepopup',
        show: isOpen,
        classNames: checkBalanceRes ? 'giftcard-resbal-modal' : 'giftcard-checkbal-modal',
        showCloseBtn: true,
        showBackBtn: false,
        closeButtonHandler: handleClose,
        modalTitle: translateWithI18Next('giftcardCheckbalnaceTitle'),
        autoFocus: true,
        closeDataTestId: 'giftcheck-balance',
        ariaLabel: translateWithI18Next('closeGiftClose'),
      };

  return (
    <div className={`giftcardContainer${isMobile ? ' mobile' : ''}`} data-testid='giftcard-checkBal'>
      {isOpen && (
        <Modal {...modalProps}>
          <div className='checkBalModalContent'>{InformationArea}</div>
          <div className='buttonGiftModal'>
            <ButtonComp
              data-testid='canc-button'
              className='button whiteButton blackBorder closebtn-cls'
              onClick={e => oncancelBtn()}
            >
              {translateWithI18Next(CHECKBALANCE_MODAL.CANCEL_BUTTONT)}
            </ButtonComp>
            <ButtonComp
              data-testid='subm-button'
              className='button blackButton blackBorder save-button'
              onClick={e => submitHandler(e)}
              disabled={buttonDisable}
            >
              {translateWithI18Next(CHECKBALANCE_MODAL.SUBMIT_BUTTON)}
            </ButtonComp>
          </div>
        </Modal>
      )}
      ;
      {checkBalanceRes && (
        <Modal {...modalProps}>
          <div className='resultBalModalContent'>
            <div className='GiftbalanceInputArea'>
              <div className='InputboxHeading'>{translateWithI18Next(CHECKBALANCE_MODAL.GIFTCARD_HEADER)}</div>

              <div className='inputcardNumboxup'>
                <TextInput
                  data-testid='result-cardnum'
                  className='details'
                  type='tel'
                  placeholder={translateWithI18Next(SHOWBALANCE_MODAL.GIFTCARDNUM_SHOW)}
                  value={cardNumberState.value}
                />
              </div>
              <div className='inputpinNumbox'>
                <TextInput
                  data-testid='result-pinnum'
                  className='details'
                  type='tel'
                  placeholder={translateWithI18Next(SHOWBALANCE_MODAL.GIFTCARDNUM_SHOWSHOW)}
                  value={pinNumberState.value}
                />
              </div>
              <div className='inputmailbox'>
                <TextInput
                  data-testid='result-mailid'
                  className='details'
                  type='email'
                  placeholder={translateWithI18Next(SHOWBALANCE_MODAL.EMAIL_SHOW)}
                  value={mailid}
                />
              </div>
            </div>
            <div className='BalanceText'>
              {translateWithI18Next('balanceText')} {currencySymbol} {balance}
            </div>
          </div>
          <div className='addPayButton'>
            <div className='payButton'>
              <ButtonComp className='button whiteButton blackBorder '>
                {translateWithI18Next(CHECKBALANCE_MODAL.CHECKBALANCE_BUTTON)}
              </ButtonComp>
            </div>
            <div className='resetButton'>
              <ButtonComp data-testid='reset-button' className='button whiteButton ' onClick={resetHandler}>
                <u>{translateWithI18Next(CHECKBALANCE_MODAL.RESET_BUTTON)}</u>
              </ButtonComp>
            </div>
          </div>
        </Modal>
      )}
      ;
      {showError && (
        <div className='checkBal-errorModal'>
          <ErrorAlertFormInsideModel
            CartAlertForm={
              <CartAlertForm
                title={translateWithI18Next(CHECKBALANCE_MODAL.INVALID_MODALTITLE)}
                contentMsg={translateWithI18Next(CHECKBALANCE_MODAL.INVALID_MODALCONTENT)}
                cancelHandler={errormodalCancel}
                cancelButtonText={translateWithI18Next(CHECKBALANCE_MODAL.INVALID_OKBUTTON)}
              />
            }
          />
        </div>
      )}
      ;
    </div>
  );
};

export default CheckbalancdeModal;
